import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import Image from "next/image";
import styled from "styled-components";

const CardWrapper = styled.div`
  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: 1.875rem;
  border: 0.1875rem solid transparent;
  margin: 0 0 1.25rem;
  padding: 1rem;
  transform: none;
  transition: transform 250ms ease-in-out;

  &:hover {
    border-color: ${({ theme, hoverColor }) =>
      hoverColor || theme.themeColors.primary};
    transform: scale3d(1.05, 1.05, 1.05);
  }

  ${({ theme }) => theme.mq.md`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `}
`;

const ImageTitleWrapper = styled.a`
  display: flex;
  flex-direction: column;
`;

const ImgWrapper = styled.div`
  position: relative;
  min-height: 11.625rem;

  ${({ theme }) => theme.mq.md`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    min-height: 7.75rem;
  `}

  ${({ theme }) => theme.mq.lg`
    min-height: 12.5rem;
  `}
`;

const CardTitle = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  font-size: 2.25rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.222;
  margin: 1.75rem 0 0;

  ${({ theme }) => theme.mq.md`
    font-size: 1.5rem;
    margin: 1.25rem 0 0;
  `}

  ${({ theme }) => theme.mq.lg`
    font-size: ${theme.fontSize(5)};
  `};
`;

function CardComponent({
  alt,
  formattedAddress,
  hoverColor,
  image,
  latitude,
  longitude,
  name,
  s,
}) {
  return (
    <CardWrapper hoverColor={hoverColor}>
      <Link
        href={{
          pathname: "/search",
          query: { s, latitude, longitude, formattedAddress },
        }}
        passHref
      >
        <ImageTitleWrapper>
          <ImgWrapper>
            <Image
              alt={alt}
              priority
              layout="fill"
              objectFit="contain"
              src={image}
            />
          </ImgWrapper>
          <CardTitle>{name}</CardTitle>
        </ImageTitleWrapper>
      </Link>
    </CardWrapper>
  );
}

export default CardComponent;

CardComponent.propTypes = {
  alt: PropTypes.string.isRequired,
  formattedAddress: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
    .isRequired,
  latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  name: PropTypes.string.isRequired,
  s: PropTypes.string.isRequired,
};

CardComponent.defaultProps = {
  hoverColor: "",
};
